import { Reveal } from "@/components/Reveal";

export function Overline({ children, className = "" }) {
  return (
    <span className={`block text-[11px] md:text-xs tracking-[0.32em] uppercase text-gold font-medium ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ children, className = "" }) {
  return (
    <h2 className={`font-serif font-light text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ivory ${className}`}>
      {children}
    </h2>
  );
}

export function Container({ children, className = "" }) {
  return <div className={`max-w-[1400px] mx-auto px-6 md:px-10 ${className}`}>{children}</div>;
}

export function GoldNumber({ children }) {
  return <span className="font-serif text-gold/25 leading-none select-none">{children}</span>;
}

export { Reveal };
